import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-skeleton-item',
  templateUrl: './skeleton-item.component.html',
  styleUrls: ['./skeleton-item.component.scss']
})
export class SkeletonItemComponent { }
